import { useMemo } from 'react';
import { useUITheme } from '@crehana/compass.ui';
import cn from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var PlayroomBadgeCardTag = function PlayroomBadgeCardTag(_ref) {
  var label = _ref.label,
    color = _ref.color,
    noColor = _ref.noColor;
  var _useUITheme = useUITheme(),
    isDark = _useUITheme.isDark;
  var className = useMemo(function () {
    if (noColor) {
      return 'tw-text-neutral-800 dark:tw-text-neutral-100';
    }
    switch (color) {
      case 'success':
        return 'tw-text-success-400';
      case 'warning':
        return 'tw-text-warning-400';
      case 'alert':
        return 'tw-text-alert-400';
      case 'primary':
        return isDark ? 'tw-text-primary-light-400' : 'tw-text-primary-dark-500';
      default:
        return 'tw-text-success-400';
    }
  }, [color, isDark, noColor]);
  return /*#__PURE__*/_jsx("div", {
    className: cn('tw-font-subtitle4 tw-mb-0.4', className),
    children: label
  });
};
export default PlayroomBadgeCardTag;